<template>
	<div v-editable="blok">
		<NuxtLink
			v-if="link"
			:to="link"
			class="transition-colors duration-300 ease-linear hover:text-blue-dark"
		>
			{{ blok.text }}
		</NuxtLink>
		<p v-else>
			{{ blok.text }}
		</p>
	</div>
</template>

<script setup lang="ts">
import type { BlokText } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokText;
}
const { blok } = defineProps<Props>();

const link = computed(() =>
	blok.Link.linktype === "story" && blok.Link.url
		? `/${blok.Link.url}`
		: blok.Link.cached_url
);
</script>
